module.exports = __webpack_public_path__ + "img/01_no.c76cc290.svg";